export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTimeOffset: { input: any; output: any; }
  Decimal: { input: any; output: any; }
};

export type Chat = {
  __typename?: 'Chat';
  models: Array<LlmModel>;
  offers: Array<LlmOffer>;
  personas: Array<Persona>;
  providers: Array<LlmProvider>;
};

export type Concept = {
  __typename?: 'Concept';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  type: Concept;
};

export type ContentItem = {
  __typename?: 'ContentItem';
  contentType?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTimeOffset']['output'];
  id: Scalars['ID']['output'];
  starred: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: ContentItemType;
};

export enum ContentItemType {
  Chat = 'CHAT',
  Document = 'DOCUMENT',
  None = 'NONE'
}

export type Conversation = {
  __typename?: 'Conversation';
  created: Scalars['DateTimeOffset']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  messages: Array<ConversationMessage>;
  persona?: Maybe<Persona>;
  starred: Scalars['Boolean']['output'];
  subject: Scalars['String']['output'];
};

export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  action?: Maybe<Scalars['String']['output']>;
  component?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  created: Scalars['DateTimeOffset']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  jsondata?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  reasoning?: Maybe<Scalars['String']['output']>;
  replyToUserId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum ConversationTemplateSource {
  Aiml = 'AIML',
  Controller = 'CONTROLLER',
  Json = 'JSON',
  Unknown = 'UNKNOWN',
  Xml = 'XML'
}

export type CreateDocumentMutationInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  softOrder?: InputMaybe<Scalars['Int']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserMutationInput = {
  email: Scalars['String']['input'];
  invitation?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userGroupId?: InputMaybe<UserGroupType>;
};

export type CreateUserMutationResult = {
  __typename?: 'CreateUserMutationResult';
  ok: Scalars['Boolean']['output'];
  token?: Maybe<TokenResponse>;
  user?: Maybe<User>;
};

export type Document = {
  __typename?: 'Document';
  content: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  created: Scalars['DateTimeOffset']['output'];
  id: Scalars['ID']['output'];
  softDeleted: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  starred: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type DocumentMutationResult = {
  __typename?: 'DocumentMutationResult';
  document?: Maybe<Document>;
  ok: Scalars['Boolean']['output'];
};

export type DocumentPreview = {
  __typename?: 'DocumentPreview';
  contentType: Scalars['String']['output'];
  created: Scalars['DateTimeOffset']['output'];
  id: Scalars['ID']['output'];
  softDeleted: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  starred: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type Entity = {
  __typename?: 'Entity';
  concept: Concept;
  contentJson: Scalars['String']['output'];
  fields: Array<Property>;
  id: Scalars['ID']['output'];
};

export type Feature = {
  __typename?: 'Feature';
  id: Scalars['ID']['output'];
};

export type GanglionMutation = {
  __typename?: 'GanglionMutation';
  /** Create a document. */
  createDocument: DocumentMutationResult;
  deleteConversation: Scalars['Boolean']['output'];
  deleteDocument: Scalars['Boolean']['output'];
  interact: InteractionResponse;
  /** Request authorization tokens for a user, based on email/password or a refresh token. */
  token?: Maybe<TokenResponse>;
  updateConversation: Conversation;
  /** Update a document. */
  updateDocument: DocumentMutationResult;
  user: UserMutations;
};


export type GanglionMutationCreateDocumentArgs = {
  input?: InputMaybe<CreateDocumentMutationInput>;
};


export type GanglionMutationDeleteConversationArgs = {
  conversation: Scalars['ID']['input'];
};


export type GanglionMutationDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type GanglionMutationInteractArgs = {
  conversation?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};


export type GanglionMutationTokenArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type GanglionMutationUpdateConversationArgs = {
  conversation: Scalars['ID']['input'];
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type GanglionMutationUpdateDocumentArgs = {
  input: UpdateDocumentMutationInput;
};

export type GanglionQuery = {
  __typename?: 'GanglionQuery';
  chat: Chat;
  entities: Array<Entity>;
  interactionTemplates: Array<InteractionTemplate>;
  invitation?: Maybe<Invitation>;
  ontology: Ontology;
  /** Profile for the calling user. */
  self?: Maybe<User>;
  systemConfig: SystemConfig;
};


export type GanglionQueryInvitationArgs = {
  token: Scalars['ID']['input'];
};


export type GanglionQueryOntologyArgs = {
  typeId?: InputMaybe<Scalars['Int']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
};

export type InteractionResponse = {
  __typename?: 'InteractionResponse';
  conversationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InteractionTemplate = {
  __typename?: 'InteractionTemplate';
  group?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  source: ConversationTemplateSource;
  topic?: Maybe<Scalars['String']['output']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type LlmModel = {
  __typename?: 'LlmModel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LlmOffer = {
  __typename?: 'LlmOffer';
  cpmCachedTokens: Scalars['Decimal']['output'];
  cpmInputTokens: Scalars['Decimal']['output'];
  cpmOutputTokens: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  model: LlmModel;
  modelIdentifier: Scalars['ID']['output'];
  provider: LlmProvider;
};

export type LlmProvider = {
  __typename?: 'LlmProvider';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  offers: Array<LlmOffer>;
};

export type Ontology = {
  __typename?: 'Ontology';
  items: Array<Concept>;
  total: Scalars['Int']['output'];
};


export type OntologyItemsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Persona = {
  __typename?: 'Persona';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Property = {
  __typename?: 'Property';
  concent: Concept;
  value: Scalars['String']['output'];
};

export enum StarredFilter {
  Any = 'ANY',
  OnlyStarred = 'ONLY_STARRED',
  OnlyUnstarred = 'ONLY_UNSTARRED'
}

export type StatusResult = {
  __typename?: 'StatusResult';
  ok: Scalars['Boolean']['output'];
};

export type SystemConfig = {
  __typename?: 'SystemConfig';
  enableInvitedSignup: Scalars['Boolean']['output'];
  enableSignup: Scalars['Boolean']['output'];
};

export type TokenResponse = {
  __typename?: 'TokenResponse';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
};

export type UpdateDocumentMutationInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  softOrder?: InputMaybe<Scalars['Int']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserMutationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  llmInstructions?: InputMaybe<Scalars['String']['input']>;
  llmPersonaId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  userGroupId?: InputMaybe<UserGroupType>;
  userId: Scalars['ID']['input'];
};

export type UpdateUserMutationResult = {
  __typename?: 'UpdateUserMutationResult';
  ok: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type Usage = {
  __typename?: 'Usage';
  total: UsageTotals;
};

export type UsageTotals = {
  __typename?: 'UsageTotals';
  /** Total cost in USD */
  cost: Scalars['Decimal']['output'];
  inputTokens: Scalars['Int']['output'];
  outputTokens: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  contentItems: Array<ContentItem>;
  conversations: Array<Conversation>;
  document?: Maybe<Document>;
  documentPreviews: Array<DocumentPreview>;
  email: Scalars['ID']['output'];
  features: Array<Feature>;
  id: Scalars['ID']['output'];
  llmInstructions: Scalars['String']['output'];
  llmPersona?: Maybe<Persona>;
  name: Scalars['ID']['output'];
  usage: Usage;
};


export type UserContentItemsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  starred?: InputMaybe<StarredFilter>;
};


export type UserConversationsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  starred?: InputMaybe<StarredFilter>;
};


export type UserDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type UserDocumentPreviewsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  starred?: InputMaybe<StarredFilter>;
};

export enum UserGroupType {
  Admin = 'ADMIN',
  None = 'NONE',
  User = 'USER'
}

export type UserMutations = {
  __typename?: 'UserMutations';
  /** Create a new user. Creating an ADMIN user requires authorization, but creating a USER does not. */
  createUser?: Maybe<CreateUserMutationResult>;
  /** Invalidates all refresh-tokens for the calling user. Other sessions will remain active until their access-tokens expire (typically 30 minutes). */
  logoutAllDevices: StatusResult;
  /** Request a validate-email email. */
  requestEmailVerificationEmail?: Maybe<StatusResult>;
  /** Request a reset-password email. */
  requestResetPasswordEmail?: Maybe<StatusResult>;
  resetPassword: StatusResult;
  /** Update a user. */
  updateUser: UpdateUserMutationResult;
  /** Validates a onetime-action token, performing any action if requred, and retuning whether the token was valid. */
  validateOnetimeToken: ValidateOnetimeTokenResult;
};


export type UserMutationsCreateUserArgs = {
  input: CreateUserMutationInput;
};


export type UserMutationsRequestEmailVerificationEmailArgs = {
  email: Scalars['String']['input'];
};


export type UserMutationsRequestResetPasswordEmailArgs = {
  email: Scalars['String']['input'];
};


export type UserMutationsResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type UserMutationsUpdateUserArgs = {
  input: UpdateUserMutationInput;
};


export type UserMutationsValidateOnetimeTokenArgs = {
  token: Scalars['String']['input'];
};

export type ValidateOnetimeTokenResult = {
  __typename?: 'ValidateOnetimeTokenResult';
  action?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expirationInSeconds?: Maybe<Scalars['Int']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CreateDocumentMutationVariables = Exact<{
  input?: InputMaybe<CreateDocumentMutationInput>;
}>;


export type CreateDocumentMutation = { __typename?: 'GanglionMutation', createDocument: { __typename?: 'DocumentMutationResult', ok: boolean, document?: { __typename?: 'Document', id: string } | null } };

export type DeleteConversationMutationVariables = Exact<{
  conversation: Scalars['ID']['input'];
}>;


export type DeleteConversationMutation = { __typename?: 'GanglionMutation', deleteConversation: boolean };

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'GanglionMutation', deleteDocument: boolean };

export type GetConversationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetConversationQuery = { __typename?: 'GanglionQuery', self?: { __typename?: 'User', conversations: Array<{ __typename?: 'Conversation', subject: string, created: any, starred: boolean, messages: Array<{ __typename?: 'ConversationMessage', id: string, index: number, created: any, contentType: string, content: string, reasoning?: string | null, model?: string | null, userId?: string | null, action?: string | null, component?: string | null, jsondata?: string | null }>, persona?: { __typename?: 'Persona', id: string, name: string } | null }> } | null };

export type GetDocumentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDocumentQuery = { __typename?: 'GanglionQuery', self?: { __typename?: 'User', document?: { __typename?: 'Document', id: string, created: any, sortOrder: number, starred: boolean, title: string, content: string, contentType: string } | null } | null };

export type GetLlmProviderOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLlmProviderOffersQuery = { __typename?: 'GanglionQuery', chat: { __typename?: 'Chat', providers: Array<{ __typename?: 'LlmProvider', name: string, offers: Array<{ __typename?: 'LlmOffer', id: string, modelIdentifier: string, cpmCachedTokens: any, cpmInputTokens: any, cpmOutputTokens: any, model: { __typename?: 'LlmModel', name: string } }> }> } };

export type GetPersonasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonasQuery = { __typename?: 'GanglionQuery', chat: { __typename?: 'Chat', personas: Array<{ __typename?: 'Persona', id: string, name: string, description: string }> } };

export type GetSystemConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSystemConfigQuery = { __typename?: 'GanglionQuery', systemConfig: { __typename?: 'SystemConfig', enableSignup: boolean, enableInvitedSignup: boolean } };

export type GetUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsageQuery = { __typename?: 'GanglionQuery', self?: { __typename?: 'User', usage: { __typename?: 'Usage', total: { __typename?: 'UsageTotals', inputTokens: number, outputTokens: number, cost: any } } } | null };

export type ListAllContentQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllContentQuery = { __typename?: 'GanglionQuery', self?: { __typename?: 'User', contentItems: Array<{ __typename?: 'ContentItem', id: string, title: string, type: ContentItemType, contentType?: string | null, created: any, starred: boolean }> } | null };

export type ListAllConversationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllConversationsQuery = { __typename?: 'GanglionQuery', self?: { __typename?: 'User', conversations: Array<{ __typename?: 'Conversation', id?: string | null, created: any, subject: string, starred: boolean }> } | null };

export type ListAllDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllDocumentsQuery = { __typename?: 'GanglionQuery', self?: { __typename?: 'User', documentPreviews: Array<{ __typename?: 'DocumentPreview', id: string, created: any, sortOrder: number, starred: boolean, title: string, contentType: string }> } | null };

export type ListRecentContentQueryVariables = Exact<{
  maxStarred?: InputMaybe<Scalars['Int']['input']>;
  maxUnstarred?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListRecentContentQuery = { __typename?: 'GanglionQuery', self?: { __typename?: 'User', starred: Array<{ __typename?: 'ContentItem', id: string, title: string, type: ContentItemType, contentType?: string | null, created: any, starred: boolean }>, recent: Array<{ __typename?: 'ContentItem', id: string, title: string, type: ContentItemType, contentType?: string | null, created: any, starred: boolean }> } | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'GanglionMutation', token?: { __typename?: 'TokenResponse', accessToken: string, refreshToken?: string | null, expiresIn: number } | null };

export type LogoutAllDevicesMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutAllDevicesMutation = { __typename?: 'GanglionMutation', user: { __typename?: 'UserMutations', logoutAllDevices: { __typename?: 'StatusResult', ok: boolean } } };

export type RequestEmailVerificationEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestEmailVerificationEmailMutation = { __typename?: 'GanglionMutation', user: { __typename?: 'UserMutations', requestEmailVerificationEmail?: { __typename?: 'StatusResult', ok: boolean } | null } };

export type RequestResetPasswordEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestResetPasswordEmailMutation = { __typename?: 'GanglionMutation', user: { __typename?: 'UserMutations', requestResetPasswordEmail?: { __typename?: 'StatusResult', ok: boolean } | null } };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'GanglionMutation', user: { __typename?: 'UserMutations', resetPassword: { __typename?: 'StatusResult', ok: boolean } } };

export type SelfUserQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfUserQuery = { __typename?: 'GanglionQuery', self?: { __typename?: 'User', id: string, name: string, email: string, llmInstructions: string, llmPersona?: { __typename?: 'Persona', id: string, name: string } | null, features: Array<{ __typename?: 'Feature', id: string }> } | null };

export type SignupMutationVariables = Exact<{
  input: CreateUserMutationInput;
}>;


export type SignupMutation = { __typename?: 'GanglionMutation', user: { __typename?: 'UserMutations', createUser?: { __typename?: 'CreateUserMutationResult', ok: boolean, user?: { __typename?: 'User', id: string, name: string, email: string } | null, token?: { __typename?: 'TokenResponse', accessToken: string, refreshToken?: string | null, expiresIn: number } | null } | null } };

export type UpdateDocumentMutationVariables = Exact<{
  input: UpdateDocumentMutationInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'GanglionMutation', updateDocument: { __typename?: 'DocumentMutationResult', ok: boolean } };

export type UpdateConversationMutationVariables = Exact<{
  conversation: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateConversationMutation = { __typename?: 'GanglionMutation', updateConversation: { __typename?: 'Conversation', id?: string | null, created: any, subject: string, starred: boolean } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserMutationInput;
}>;


export type UpdateUserMutation = { __typename?: 'GanglionMutation', user: { __typename?: 'UserMutations', updateUser: { __typename?: 'UpdateUserMutationResult', ok: boolean, user?: { __typename?: 'User', id: string, name: string, email: string } | null } } };

export type ValidateInvitationQueryVariables = Exact<{
  token: Scalars['ID']['input'];
}>;


export type ValidateInvitationQuery = { __typename?: 'GanglionQuery', invitation?: { __typename?: 'Invitation', name?: string | null, email?: string | null, valid: boolean } | null };

export type ValidateOnetimeTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ValidateOnetimeTokenMutation = { __typename?: 'GanglionMutation', user: { __typename?: 'UserMutations', validateOnetimeToken: { __typename?: 'ValidateOnetimeTokenResult', ok: boolean, email?: string | null, action?: string | null, expirationInSeconds?: number | null } } };
